import { render, staticRenderFns } from "./Aktivasyon.vue?vue&type=template&id=cef15f7e&"
import script from "./Aktivasyon.vue?vue&type=script&lang=js&"
export * from "./Aktivasyon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports